module.exports = "<mat-progress-bar mode=\"indeterminate\"\r\n                  *ngIf=\"loading\">\r\n</mat-progress-bar>\r\n"